import React from 'react';
import { View, Text, StyleSheet, Pressable, Linking } from 'react-native';

import OPComponent from '../op_component';

import { __WEB__, THEME } from '../../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getFileByTypeAndId } from '../actions';
import { getFilesForEditingObject } from '../selector';

import { getFullscreenImageUrl } from './web_fullscreen';

class AttachmentsLinksList extends OPComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { objectType, objectId } = this.props;
    this.props.actions.getFileByTypeAndId(objectType, objectId);
  }

  showFullScreen = async (attachment) => {
    const url = await getFullscreenImageUrl(attachment);
    if (url) {
      if (__WEB__) {
        window.open(url, '_blank');
      } else {
        Linking.canOpenURL(url).then((supported) => {
          if (supported) {
            return Linking.openURL(url);
          }
        });
      }
    }
  };

  renderLink = (attachment, i) => {
    return (
      <Pressable
        key={i}
        onPress={() => {
          this.showFullScreen(attachment);
        }}
      >
        <Text style={[THEME.linkStyle, { textDecorationLine: 'underline', paddingVertical: 10 }]}>
          {attachment?.fileName}
        </Text>
      </Pressable>
    );
  };

  render() {
    const { savedFiles, constainerStyle } = this.props;

    if (!savedFiles?.length) return null;

    return <View style={[constainerStyle]}>{savedFiles.map(this.renderLink)}</View>;
  }
}

const styles = StyleSheet.create({});

function mapStateToProps(state, ownProps) {
  return {
    savedFiles: getFilesForEditingObject(state, ownProps),
    status: state.screens.components.uploads.status,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getFileByTypeAndId,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsLinksList);
